import {Action} from "puzzle";

export const TestAction: Action = [{
    moduleName: "Dispatcher",
    name: 'TestActions'
}];
